import { Pipe, PipeTransform } from "@angular/core";
import _ from "lodash/object";

/** @deprecated */
@Pipe({ name: "values", pure: false })
export class ValuesPipe implements PipeTransform {
  transform(value: Object) {
    return _.values(value);
  }
}
